import { Link } from "react-router-dom";

const COLUMNS = [
  {
    title: "内容频道",
    links: [
      { label: "影视剧", to: "/category/movie" },
      { label: "小说阅读", to: "/category/novel" },
      { label: "娱乐资讯", to: "/category/news" },
    ],
  },
  {
    title: "热门入口",
    links: [
      { label: "科幻影视", to: "/category/movie" },
      { label: "玄幻小说", to: "/category/novel" },
      { label: "明星动态", to: "/category/news" },
    ],
  },
  {
    title: "快速导航",
    links: [
      { label: "首页", to: "/" },
      { label: "内容搜索", to: "/search" },
      { label: "影视分类", to: "/category/movie" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading font-black text-lg">
                17
              </span>
              <span className="font-heading font-black text-xl tracking-tight">
                17C<span className="text-accent-400">.</span>COM
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-200">
              综合性娱乐平台，聚合影视剧展示、小说在线阅读与最新娱乐资讯，满足多元化的内容浏览需求。
            </p>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-base font-bold mb-4 text-background-50">
                {col.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-200 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-secondary-700/60">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-background-200">
            © {new Date().getFullYear()} 17C.COM 综合娱乐平台 · 站内内容均为演示示例
          </p>
          <p className="text-xs text-background-200">
            影视 · 小说 · 资讯，一站式娱乐内容聚合
          </p>
        </div>
      </div>
    </footer>
  );
}